// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.real-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/components/FileInput/FileInput.scss"],"names":[],"mappings":"AAIA;EACE,YAAA;EACD,aAAA;EACA,UAAA;EACA,gBAAA;EACC,kBAAA;EACD,WAAA;AAHD","sourcesContent":["\n@import '../../scss/colors';\n@import '../../scss/globals';\n\n.real-input {\n  width: 0.1px;\n\theight: 0.1px;\n\topacity: 0;\n\toverflow: hidden;\n  position: absolute;\n\tz-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
